import scheme from './schemes/fotometadaten.config.js'
import _ from 'lodash'

const yyyymmdd = function(){
	var d = new Date(),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) 
		month = '0' + month;
	if (day.length < 2) 
		day = '0' + day;

	return [year, month, day].join('-');
}
const hhmm = function(){
	const date = new Date();
	let currentHours = date.getHours();
	currentHours = ("0" + currentHours).slice(-2);
	let currentMinutes = (date.getMinutes()<10?'0':'') + date.getMinutes()

	return currentHours + '-' + currentMinutes
}

//console.log('second • scheme:', scheme)

export default { 
	scheme  : scheme,
	csvTableLayout : 'horizontal',
	computed: {
		title(){
			let user  = this.pairs['auftraggeber_in']
				user  = _.camelCase( user )
				user  = _.upperFirst( user )


			let part1 = yyyymmdd() + '--' + hhmm()
			let part2 = user ? '--' + user : ''
			let part3 = '.csv'
			
			return 'Fotoauftrag--' + part1 + part2 + part3
		}
	},
	methods : {},	
}